import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.5,4v-.75c0-1.517-1.233-2.75-2.75-2.75H3.25C1.733.5.5,1.733.5,3.25v.75h11Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m5.5,5.5v6h3.25c1.517,0,2.75-1.233,2.75-2.75v-3.25h-6Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m4,5.5H.5v3.25c0,1.517,1.233,2.75,2.75,2.75h.75v-6Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGrid3Fill12.js.map